export default __webpack_public_path__ + "static/media/account_02.ee89a91c.png";